import { COLUMN_GAP, MAX_COLUMNS, NODE_WIDTH, ROW_GAP, TARGET_ASPECT } from "./graphLayout";

export const columnsForAspect = (count: number): number => {
    const cellAspect = ROW_GAP / (NODE_WIDTH + COLUMN_GAP);
    const ideal = Math.round(Math.sqrt(count * TARGET_ASPECT * cellAspect));
    return Math.min(Math.max(ideal, 1), MAX_COLUMNS);
};
